import { GAME_TYPES, PLAYER_BET_HISTORIES } from '~/utils/api-response/player'

// State
export const state = () => ({
  loading: false,
  gameTypes: [],
  betHistory: {
    total: 0,
    totalPages: 0,
    data: [],
    total_overall_bet_count: 0,
    total_overall_bet_amount: 0,
    total_overall_turnover_amount: 0,
    total_overall_win_loss_amount: 0
  }
})

// Actions
export const actions = {
  // Get Game Type
  getGameType({ commit }) {
    const response = GAME_TYPES

    commit('setGameType', response.data)
  },
  // Get bet history
  getBetHistory({ commit }, params) {
    const response = PLAYER_BET_HISTORIES
    commit('setBetHistory', response.data)
  }
}

// Mutations
export const mutations = {
  setLoading(state, data) {
    state.loading = data
  },
  setGameType(state, data) {
    state.gameTypes = data
  },
  setBetHistory(state, data) {
    state.betHistory = data
  }
}

// Getters
export const getters = {
  gameTypes: state => state.gameTypes,
  betHistory: state => state.betHistory
}
